<template>
  <div class="card">
    <div
      :class="cardClass"
      @click="onClick"
      :style="isActive ? 'background-color: ' + primary : ''"
    >
      <p>{{ item.name }}</p>
      <span>{{ item.address }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-rectangle",
  props: {
    item: {
      type: [Object],
      default: null
    },
    active: {
      type: [Number],
      default: -1
    }
  },
  computed: {
    cardClass() {
      return this.active === this.item.id
        ? "card-content card-content__active"
        : "card-content";
    },
    isActive() {
      return this.active === this.item.id;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  methods: {
    onClick() {
      this.$emit("cardclick", this.item.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 10px 0;
  &-content {
    transition: all 0.2s;
    cursor: pointer;
    width: 100%;
    padding: 20px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    box-shadow: 0 3px 15px 0px rgba(0, 0, 0, 0.1);
    margin-right: 20px;
    p {
      margin-bottom: 0;
    }
    span {
      font-size: 12px;
    }
    &__active {
      background-color: $gray-500;
      color: white;
    }
    &:hover {
      background-color: $gray-400;
      color: white;
    }
  }
}
</style>
